import { Box, Button, Stack, SvgIconTypeMap, Typography } from "@mui/material";
import { colours } from "../../StyleConstants";
import React from "react";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from "react-router-dom";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { useUserInfoQuery } from "../../api/userApiSlice";

interface buttonData {
    // eslint-disable-next-line
    icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
    title: string;
    subTitle: string;
    link?: string
    disabled?: boolean
}

const SF_PAGE_NAME = "tickets"
const kcUrl = window.env.keycloak.url;
const realm = window.env.keycloak.realm;

const HelpCenterPage = () => {

    const { data: userData } = useUserInfoQuery({});

    const defaultSFUrl: () => URL = () => {
        const username = userData?.username || userData?.email || "unknown";
        const defaultURL = new URL(`${window.env.salesforcePortalURL}redirect`);
        defaultURL.searchParams.set("issuer", `${kcUrl}realms/${realm}`);
        defaultURL.searchParams.set("study", window.env.salesforceStudy);
        defaultURL.searchParams.set("username", username);
        return defaultURL;
    };

    const generateCreateIssueButtonUrl: () => string = () => defaultSFUrl().toString()

    const generateManageTicketsUrl = () => {
        const url = defaultSFUrl();
        const searchParams = new URLSearchParams(window.location.search)
        const sfTicketNumber = searchParams.get("questionid");
        url.searchParams.set("page", SF_PAGE_NAME);
        if (sfTicketNumber) {
            url.searchParams.set("questionid", sfTicketNumber);
            return url.toString();
        }
        return url.toString();
    }

    const navigate = useNavigate();

    const role = userData ? userData.roles : ["SUMMARY"];

    const buttonData: buttonData[] = [
        {
            icon: OpenInNewIcon,
            title: "Create An Issue",
            subTitle: "Open Issue Tracker to create and view issues",
            link: generateCreateIssueButtonUrl(),
            disabled: !role.includes("SUBJECT")
        },
        {
            icon: OpenInNewIcon,
            title: "Manage Tickets",
            subTitle: "Open the Issue Tracker to view and manage your tickets",
            link: generateManageTicketsUrl(),
            disabled: !role.includes("SUBJECT")
        },
        {
            icon: OpenInNewIcon,
            title: "ABCD Data Documentation",
            subTitle: "Main ABCD documentation website containing information about data curation/structure, measure descriptions, and release notes",
            link: window.env.abcdWiki
        },
        {
            icon: OpenInNewIcon,
            title: "HBCD Data Release Docs",
            subTitle: "Main HBCD documentation website containing information about data curation/structure, measure descriptions, and release notes",
            link: window.env.hbcdWiki
        },
        {
            icon: OpenInNewIcon,
            title: "ABCD Private Data Documentation",
            subTitle: "Website containing release notes with protected information; only available to users who are DUC-approved and have completed the NBDC Responsible Data and Biospecimen Use Training",
            link: window.env.abcdPrivateWiki,
            disabled: !role.includes("SUBJECT")
        },
        {
            icon: OpenInNewIcon,
            title: "HBCD Private Release Notes",
            subTitle: "Website containing release notes with protected information; only available to users who are DUC-approved and have completed the NBDC Responsible Data and Biospecimen Use Training",
            link: window.env.hbcdPrivateWiki,
            disabled: !role.includes("SUBJECT")
        },
        {
            icon: OpenInNewIcon,
            title: "Training Videos",
            subTitle: "Access our trainings",
            link: "/help-center/videos"
        },
    ]

    const renderButtons = () => {
        return buttonData.map((button) => (
            <Box sx={{ width: '40%' }} key={button.title}>
                <Button
                    variant="primary"
                    id={`help-center-nav-link-${button.title}`}
                    onClick={() => handleClick(button.link)}
                    disabled={button?.disabled}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        height: '100%',
                        padding: '2rem',
                        backgroundColor: colours.orange.orange10,
                    }}>

                    <button.icon
                        sx={{
                            fontSize: '24px',
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                        }}
                    />

                    <Typography
                        variant="h2"
                        fontWeight="600"
                        fontSize="18px"
                        color={button.disabled ? 'gray' : 'black'}>
                        {button.title}
                    </Typography>
                    <Typography
                        variant="body2"
                        color={button.disabled ? 'gray' : 'black'}
                    >
                        {button.subTitle}
                    </Typography>
                </Button>
            </Box>

        ));
    }
    const handleClick = (link: string | undefined) => {
        if (link) {
            if (link.indexOf("http") !== -1) {
                window.open(link, "_blank");
            } else {
                navigate(link);
            }
        }
    }

    return (

        <Stack
            flexDirection="column"
            gap={3}
            overflow="auto"
            height="100%"
        >
            <Typography
                variant="h1"
                fontWeight="600"
                fontSize="38px"
                textAlign="center"
                color={colours.midnightBlue.blue}>
                Find what you need!
            </Typography>
            <Stack flexDirection="row"
                gap={3}
                flexWrap="wrap"
                justifyContent="center">
                {renderButtons()}
            </Stack>
        </Stack>
    )
}

export default HelpCenterPage;